import { FC } from 'react';
import { Tag } from 'antd';
import { UserOutlined, CrownOutlined, SettingOutlined, TeamOutlined } from '@ant-design/icons';
import { AC_Organization_Role, AC_Organization } from '~/common/typescript/services/access_control/AC_Organization';

interface OrganizationRoleTagProps {
  role: AC_Organization_Role;
  hideLabel?: boolean;
}

const getRoleIcon = (role: AC_Organization_Role) => {
  switch (role) {
    case AC_Organization_Role.ORGANIZATION_OWNER:
      return <CrownOutlined />;
    case AC_Organization_Role.ORGANIZATION_ADMIN:
      return <SettingOutlined />;
    case AC_Organization_Role.ORGANIZATION_EDITOR:
      return <TeamOutlined />;
    case AC_Organization_Role.ORGANIZATION_MEMBER:
    default:
      return <UserOutlined />;
  }
};

const getRoleColor = (role: AC_Organization_Role) => {
  switch (role) {
    case AC_Organization_Role.ORGANIZATION_OWNER:
      return 'gold';
    case AC_Organization_Role.ORGANIZATION_ADMIN:
      return 'red';
    case AC_Organization_Role.ORGANIZATION_EDITOR:
      return 'orange';
    case AC_Organization_Role.ORGANIZATION_MEMBER:
    default:
      return 'blue';
  }
};

const OrganizationRoleTag: FC<OrganizationRoleTagProps> = ({ role, hideLabel }) => {
  return (
    <Tag
      icon={getRoleIcon(role)}
      color={getRoleColor(role)}
      style={{
        fontSize: '11px',
        padding: '1px 4px',
        marginInlineEnd: 0
      }}
    >
      {!hideLabel && AC_Organization.getRoleName(role)}
    </Tag>
  );
};

export default OrganizationRoleTag;